<script type="text/ecmascript-6">
    import RadioQuestion from "../mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Frame Material:';
                }
            },
            component_id: {
                default(){
                    return 'frame_material';
                }
            },
            slab: {
                required: true,
            },
            doorRange: {
                default(){
                    return 1;
                }
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/frame-material?slab=' + this.slab + '&fabricator_id=' + this.fabricator + '&door_range=' + this.doorRange;
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.doorRange);
            },
            cache_key(){
                return '_' + this.slab + '_' + this.doorRange;
            },
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
